/** @format */

import React from 'react';
import jMoment from 'moment-jalaali';
import { Grid, Button, Typography } from '@mui/material';
import { ConfirmDialog, Icons } from 'components';
import { getDynamicObjectAction } from 'utility';
import { useStyles } from './Style';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../../hooks';

import ActiveDevicesServices from '../services/ActiveDevicesServices';

export default function ActiveDeviceItem({ data, refreshList, current, ...props }) {
  // --STATES--//

  const { openDialog, setOpenDialog, loading, setLoading } = useCustomHook();
  // --HOOKS--//
  const actionsList =
    getDynamicObjectAction([
      'deviceBusinessBtn',

    ]);
  const classes = useStyles();

  // --API--//
  const deleteDevice = async () => {
    let result;
    setLoading(true);
    try {
      result = await ActiveDevicesServices.deleteDevice(data?.uid);
      createToast('موفق', `دستگاه با موفقیت خارج شد`, 'success');

      setLoading(false);
      setOpenDialog(false);
      refreshList();
    } catch (error) {
      setLoading(false);
    }
  };

  const getIcon = (type) => {
    const i =  <Icons icon='monitor' color='#2B3990' size='25' />;
    switch (type) {
      case 'Mobile Phone':
      case 'Mobile Device':
        return  <Icons icon='mobile' color='#2B3990' size='25' />;
      case 'Desktop':
        return <Icons icon='monitor' color='#2B3990' size='25' />;
      case 'Tablet':
        return <Icons icon='tablet' color='#2B3990' size='25' />;
      case 'Console':
        return<Icons icon='video' color='#2B3990' size='25' />;
      case 'TV Device':
        return<Icons icon='tv' color='#2B3990' size='25' />;
      default:
        break;
    }
    return i;
  };

  return (
    <Grid
      className={`${classes.root} ${data?.current ? 'current-device' : ''}`}
      container
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item>{getIcon(data?.deviceType)}</Grid>
      <Grid item xs={12} md={2} className={classes.keyTitlePart}>
        <Typography variant="h5" className={classes.keyTitle}>
          {data?.deviceType ?? '-'}
        </Typography>
        {data?.current ? (
          <Typography variant="h5" className={classes.currentDevice}>
            دستگاه جاری
          </Typography>
        ) : null}
      </Grid>

      <Grid item xs={12} md={2} className={classes.clientPart}>
        <Typography variant="h5" className={classes.clientTitle}>
          آی‌پی دستگاه
        </Typography>
        <Typography variant="h6" className={classes.clientDesc}>
          {data?.ip ?? '-'}
        </Typography>
      </Grid>

      <Grid item xs={12} md={2} className={classes.clientPart}>
        <Typography variant="h5" className={classes.clientTitle}>
          سیستم عامل
        </Typography>
        <Typography variant="h6" className={classes.clientDesc}>
          {data?.os ?? ''} {data?.osVersion ? `- ${data.osVersion}` : ''}
          {!data?.os && !data?.osVersion ? '-' : ''}
        </Typography>
      </Grid>

      <Grid item xs={12} md={2} className={classes.clientPart}>
        <Typography variant="h5" className={classes.clientTitle}>
          مرورگر
        </Typography>
        <Typography variant="h6" className={classes.clientDesc}>
          {data?.browser ?? ''} {data?.browserVersion ? `- ${data.browserVersion}` : ''}
          {!data?.browser && !data?.browserVersion ? '-' : ''}
        </Typography>
      </Grid>

      <Grid item xs={12} md={2} className={classes.clientPart}>
        <Typography variant="h5" className={classes.clientTitle}>
          آخرین ورود
        </Typography>
        <Typography variant="h6" className={classes.clientDesc}>
          {jMoment(data?.lastAccessTime).format('dddd, jD jMMMM jYYYY - HH:mm')}
        </Typography>
      </Grid>

      <Grid item className={classes.actions}>
        {actionsList['deviceBusinessBtn'] && (
          <Button
            variant="outlined"
            color="primary"
            className={classes.expandBtn}
            disabled={data?.current}
            onClick={() => setOpenDialog(true)}
          >
            خروج
          </Button>
        )}

      </Grid>

      {/* Confirm Delete */}
      <ConfirmDialog
        open={openDialog}
        loading={loading}
        onClose={() => setOpenDialog(false)}
        onConfirm={() => deleteDevice()}
        title="تایید خروج دستگاه"
        content="آیا از خروج دستگاه انتخاب شده اطمینان دارید؟"
        confirmButtonText="خروج دستگاه"
        cancelButtonProps="انصراف"
      />
    </Grid>
  );
}
